// extracted by mini-css-extract-plugin
export var text = "_aq-0";